module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAHlBMVEUAAAAmJS4mJS8mJS8lJS4nJC4lJS8gICAgIComJS9lK8MsAAAACXRSTlMA5PPPx3BMCBhT6c6yAAAAYklEQVQ4y2MYrCBxJgiohIPYpU5gjhhYQnImGExuYGDgsISwJ4IlZkKBOQNDMYyNIjGVgSESq8QUBgZPrBKTGBg0USUQvJmjEqMSQ0lCElUCkXESMSXEUDMjUAoOKJegBAAADB2AjgxhFRMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/book-open-fill@2x.png
// module id = BSBa
// module chunks = 44